module.exports = __webpack_public_path__ + "img/dinner-table.413f572b.svg";